module.exports = __webpack_public_path__ + "static/media/hotel.f55ce7ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/services/meet_and_greet/hotel.jpg
// module id = 167
// module chunks = 0 2